"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _Promotions = require("self-service-api/constants/Promotions");

var _ProductsAndPlansNavIds = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _PromotionBanner = _interopRequireDefault(require("./PromotionBanner"));

var PromotionBannerContainer = function PromotionBannerContainer(props) {
  var _ProductsAndPlansNavI;

  var getProductPromotionEligibilityMap = props.getProductPromotionEligibilityMap,
      hub = props.hub,
      products = props.products,
      eligibleDiscounts = props.eligibleDiscounts;

  if (!products) {
    return null;
  } // functions currently used to retrieve copy keys for Brazil and LATAM-ES


  var getRegionalSalesPromotionCopyKey = function getRegionalSalesPromotionCopyKey(promotionKey) {
    var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020);
    var professionalPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019);

    if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'sales';
    } else if (professionalPromotionEligibilityMap && professionalPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'salesOnlyProfessional';
    }

    return null;
  };

  var getRegionalServicePromotionCopyKey = function getRegionalServicePromotionCopyKey(promotionKey) {
    var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020);
    var professionalPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL);

    if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'service';
    } else if (professionalPromotionEligibilityMap && professionalPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'serviceOnlyProfessional';
    }

    return null;
  };

  var getRegionalMarketingPromotionCopyKey = function getRegionalMarketingPromotionCopyKey(promotionKey) {
    var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019);

    if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'marketing';
    }

    return null;
  };

  var getRegionalCmsHubPromotionCopyKey = function getRegionalCmsHubPromotionCopyKey(promotionKey) {
    var professionalPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_CMS_PROFESSIONAL);

    if (professionalPromotionEligibilityMap && professionalPromotionEligibilityMap.eligiblePromotion === promotionKey) {
      return 'cmsHub';
    }

    return null;
  };

  var regionalPromotionCopyKeyGetter = (_ProductsAndPlansNavI = {}, (0, _defineProperty2.default)(_ProductsAndPlansNavI, _ProductsAndPlansNavIds.default.SALES, getRegionalSalesPromotionCopyKey), (0, _defineProperty2.default)(_ProductsAndPlansNavI, _ProductsAndPlansNavIds.default.SERVICE, getRegionalServicePromotionCopyKey), (0, _defineProperty2.default)(_ProductsAndPlansNavI, _ProductsAndPlansNavIds.default.MARKETING, getRegionalMarketingPromotionCopyKey), (0, _defineProperty2.default)(_ProductsAndPlansNavI, _ProductsAndPlansNavIds.default.CMS_HUB, getRegionalCmsHubPromotionCopyKey), _ProductsAndPlansNavI)[hub];

  var isEligibleForPromotion = function isEligibleForPromotion(promotionKey) {
    return eligibleDiscounts.includes(promotionKey);
  };

  return _react.default.createElement(_react.default.Fragment, null, regionalPromotionCopyKeyGetter && _react.default.createElement(_PromotionBanner.default, {
    shouldShow: regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.LATAM_ES),
    promotion: _Promotions.promotionKeys.LATAM_ES,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.latamEs." + regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.LATAM_ES) + ".title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.latamEs." + regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.LATAM_ES) + ".body_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        url: (0, _urls.getLatamEsPromotionUrl)()
      }
    }),
    dataSelenium: _Promotions.promotionKeys.LATAM_ES.toLowerCase() + "-promotion-header"
  }), regionalPromotionCopyKeyGetter && _react.default.createElement(_PromotionBanner.default, {
    shouldShow: regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.BRAZIL),
    promotion: _Promotions.promotionKeys.BRAZIL,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.brazil." + regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.BRAZIL) + ".title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.brazil." + regionalPromotionCopyKeyGetter(_Promotions.promotionKeys.BRAZIL) + ".body_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        url: (0, _urls.getBrazilPromotionUrl)()
      }
    }),
    dataSelenium: _Promotions.promotionKeys.BRAZIL.toLowerCase() + "-promotion-header"
  }), _react.default.createElement(_PromotionBanner.default, {
    shouldShow: isEligibleForPromotion(_Promotions.promotionKeys.HSFS_SEED),
    promotion: _Promotions.promotionKeys.HSFS_SEED,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.hsfx.seed.title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.hsfx.seed.body_jsx",
      elements: {}
    }),
    cta: {
      url: (0, _urls.getHSFSPurchaseUrl)(),
      message: 'pricingPage.promotions.hsfx.cta'
    }
  }), _react.default.createElement(_PromotionBanner.default, {
    shouldShow: isEligibleForPromotion(_Promotions.promotionKeys.HSFX_ENTREPRENEUR),
    promotion: _Promotions.promotionKeys.HSFX_ENTREPRENEUR,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.hsfx.entrepreneur.title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.hsfx.entrepreneur.body_jsx",
      elements: {}
    }),
    cta: {
      url: (0, _urls.getHSFSPurchaseUrl)(),
      message: 'pricingPage.promotions.hsfx.cta'
    }
  }), _react.default.createElement(_PromotionBanner.default, {
    shouldShow: isEligibleForPromotion(_Promotions.promotionKeys.HSFX_BOOTSTRAP),
    promotion: _Promotions.promotionKeys.HSFX_BOOTSTRAP,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.hsfx.bootstrap.title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.hsfx.bootstrap.body_jsx",
      elements: {}
    }),
    cta: {
      url: (0, _urls.getHSFSPurchaseUrl)(),
      message: 'pricingPage.promotions.hsfx.cta'
    }
  }), _react.default.createElement(_PromotionBanner.default, {
    shouldShow: isEligibleForPromotion(_Promotions.promotionKeys.HSFS_SERIES_A),
    promotion: _Promotions.promotionKeys.HSFS_SERIES_A,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.hsfx.series-a.title"
    }),
    description: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.promotions.hsfx.series-a.body_jsx",
      elements: {}
    }),
    cta: {
      url: (0, _urls.getHSFSPurchaseUrl)(),
      message: 'pricingPage.promotions.hsfx.cta'
    }
  }));
};

PromotionBannerContainer.propTypes = {
  hub: _propTypes.default.string.isRequired,
  eligibleDiscounts: _propTypes.default.array.isRequired,
  products: _propTypes.default.object,
  getProductPromotionEligibilityMap: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    eligibleDiscounts: (0, _PromotionSelectors.allEligibleDiscountsSelector)(state),
    getProductPromotionEligibilityMap: (0, _PromotionSelectors.getProductPromotionEligibilityMapSelector)(state),
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PromotionBannerContainer);

exports.default = _default;
module.exports = exports.default;